import { Icon } from "@iconify/react";
import { SortDescriptor } from "@progress/kendo-data-query";
import {
  Grid,
  GridCellProps,
  GridColumn as Column,
  GridSortChangeEvent,
  GridNoRecords,
} from "@progress/kendo-react-grid";
import React, { useState } from "react";
//import "./tablestyle.scss";


function CRresourcesTable(props: any) {

    const initialSort: Array<SortDescriptor> = [
        { field: "", dir: "asc" },
      ];
    
    const [sort, setSort] = useState(initialSort);
   
  const jobRoleCell = (props: GridCellProps) => {
  
    return (
      <td>
        {props.dataItem.jobRoles && props.dataItem.jobRoles.length > 0 && props.dataItem.jobRoles.toString()}
      </td>
    )
}
    
  const dateCell = (props: GridCellProps) => {
    return (
      <td>
       {props.dataItem.dateOfRegistration && new Date(parseInt(props.dataItem.dateOfRegistration)).toDateString().slice(3)}
      </td>
    )
  }

  const skillCell = (props: GridCellProps) => {
    return (
      <td>
        <div className="skillsWrap">
          {props.dataItem.skills && props.dataItem.skills.toString()}
        </div>
      </td>
    )
  }

  const redirection = (loginId: string) => {
    localStorage.setItem('candidateLoginId', loginId)
    localStorage.setItem('ResourcesCandidateLoginId', loginId)
    openInNewTab(`${window.location.origin}/CRcreateresources`)

  }

  const openInNewTab = (url: any) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const nameCell = (props: GridCellProps) => {
    return (
      <td onClick={() => redirection(props.dataItem.loginId)}>
        {props.dataItem.name}
      </td>
    )
  }

  return (
    <>
      <Grid
        data={props.state.items}
        onPageChange={props.pageChange}
        total={props.state.total}
        skip={props.state.skip}
        pageable={props.state.pageable}
        pageSize={props.state.pageSize}
        onItemChange={props.itemChange}
        // onRowClick={(e) => rowClick(e)}
        // data={props.state.items && orderBy(props.state.items, sort)}
        // onSortChange={(e: GridSortChangeEvent) => {
        //   setSort(e.sort); props.getTableValues()
        // }}
        sortable={true}
        sort={sort}
        onSortChange={(e) => {
          setSort(e.sort);
          props.setSort(e.sort);
          props.applySort(e.sort);

         }}
      >
        <GridNoRecords>
          <div className="noData">
            <Icon icon="mdi:smiley-neutral-outline" />
            No data to display
          </div>
        </GridNoRecords>
        <Column field="name" title="Name" width="180" className="noWordWrap" cell={nameCell}/>
        {/* <Column field="Skills" title="Skills" cell={skillCell}/> */}
        <Column field="experience" title="Experience" />
        <Column field="jobRole" title="Job role" cell={jobRoleCell} />
        <Column field="sourcedBy" title="Sourced By" />
        <Column field="ellowStatus" title="ellow status" />
        <Column field="date_of_registration" title="Date of Registration" cell={dateCell}/>
        <Column field="allocatedTo" title="Allocated To" />
        {/* <Column width="120px" />
        <Column width="70px" /> */}
      </Grid>
    </>
  );
}

export default CRresourcesTable;
